import type { TheSidebarProps } from "@/widgets/sidebar/model";
import { CarrierSidebar } from "@/widgets/sidebar/ui/carrier-sidebar";
import { ShipperCarrierSidebar } from "@/widgets/sidebar/ui/shipper-carrier-sidebar";
import { ShipperSidebar } from "@/widgets/sidebar/ui/shipper-sidebar";
import { SystemAdminItems } from "@/widgets/sidebar/ui/system-admin-items";
import { XmileSystemAdminItems } from "@/widgets/sidebar/ui/xmile-system-admin-items";
import CloseIcon from "@mui/icons-material/Close";
import { Box, Divider, Drawer, IconButton } from "@mui/material";
import { SIDEBAR_WIDTH } from "../constant";

// WORKAROUND: Material DesignのDrawerは画面高さ一杯に表示されることを期待しているが、デザインが噛み合っていないためマージンを指定している
const APP_BAR_HEIGHT = 64;

type MobileProps = {
  mobileOpen: boolean;
  onMobileClose: () => void;
};

type Props = TheSidebarProps & MobileProps;

/**
 * レスポンシブ対応済みのサイドバー
 */
export const TheSidebarUi = ({
  isShipper,
  isCarrier,
  isSystemAdmin,
  isXmileSystemAdmin,
  companyId,
  currentPath,
  notificationBadgeNumber,
  logout,
  mobileOpen,
  onMobileClose,
}: Props) => {
  const sidebarItems = (
    <>
      {isShipper && isCarrier ? (
        <ShipperCarrierSidebar
          currentPath={currentPath}
          notificationBadgeNumber={notificationBadgeNumber}
          logout={logout}
        />
      ) : isShipper ? (
        <ShipperSidebar
          currentPath={currentPath}
          notificationBadgeNumber={notificationBadgeNumber}
          logout={logout}
        />
      ) : isCarrier ? (
        <CarrierSidebar
          currentPath={currentPath}
          notificationBadgeNumber={notificationBadgeNumber}
          logout={logout}
        />
      ) : null}

      {isSystemAdmin && (
        <SystemAdminItems currentPath={currentPath} companyId={companyId} />
      )}

      {isXmileSystemAdmin && (
        <XmileSystemAdminItems currentPath={currentPath} />
      )}
    </>
  );

  return (
    <>
      {/* デスクトップ向け */}
      <Drawer
        variant="permanent"
        sx={{
          display: { xs: "none", sm: "block" },
          width: SIDEBAR_WIDTH,
          flexShrink: 0,
          "& .MuiDrawer-paper": {
            width: SIDEBAR_WIDTH,
            boxSizing: "border-box",
            py: "10px",
          },
        }}
      >
        {/* WORKAROUND: Material DesignのDrawerは画面高さ一杯に表示されることを期待しているが、デザインが噛み合っていないためマージンを指定している */}
        <Box sx={{ height: APP_BAR_HEIGHT }} />
        <Box sx={{ overflow: "auto" }}>{sidebarItems}</Box>
      </Drawer>

      {/* モバイル向け */}
      <Drawer
        variant="temporary"
        anchor="right"
        open={mobileOpen}
        onClose={onMobileClose}
        sx={{
          display: { xs: "block", sm: "none" },
        }}
      >
        <Box sx={{ width: "256px" }}>
          <Box display="flex" justifyContent="flex-end">
            <IconButton
              onClick={onMobileClose}
              sx={{ width: "56px", height: "56px" }}
            >
              <CloseIcon sx={{ fontSize: "24px", color: "primary.400" }} />
            </IconButton>
          </Box>

          <Divider
            orientation="horizontal"
            variant="fullWidth"
            flexItem
            sx={{
              backgroundColor: "white",
            }}
          />

          {sidebarItems}
        </Box>
      </Drawer>
    </>
  );
};
